import { useFeatureFlags } from '@npco/mp-utils-mp-feature-flags'
import { useTranslations } from '@npco/utils-translations'
import { SvgIcon } from '@npco/zeller-design-system'

import { ReactComponent as ItemsIcon } from 'assets/svg/items.svg'
import { ROOT } from 'const/routes'

import { ItemToggle } from '../components/ItemToggle/ItemToggle'
import { translations } from './ItemsItem.i18n'

export const ItemsItem = () => {
  const t = useTranslations(translations)
  const flags = useFeatureFlags()

  if (!flags.POSItems) {
    return null
  }

  const subItems = [
    {
      subitemTitle: t('catalogue'),
      subitemPath: ROOT.PORTAL.ITEMS.CATALOGUE.path,
    },
    {
      subitemTitle: t('categories'),
      subitemPath: ROOT.PORTAL.ITEMS.CATEGORIES.path,
    },
    {
      subitemTitle: t('attributeSets'),
      subitemPath: ROOT.PORTAL.ITEMS.ATTRIBUTE_SETS.path,
    },
    {
      subitemTitle: t('modifierSets'),
      subitemPath: ROOT.PORTAL.ITEMS.MODIFIER_SETS.path,
    },
    {
      subitemTitle: t('discounts'),
      subitemPath: ROOT.PORTAL.ITEMS.DISCOUNTS.path,
    },
    {
      subitemTitle: t('settings'),
      subitemPath: ROOT.PORTAL.ITEMS.SETTINGS.path,
    },
  ]

  return (
    <ItemToggle
      icon={
        <SvgIcon>
          <ItemsIcon />
        </SvgIcon>
      }
      subItems={subItems}
      name="Items"
      className="nav-item-items"
    >
      {t('items')}
    </ItemToggle>
  )
}
